module.exports = __webpack_public_path__ + "static/img/ry9.197d243.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/ry9.jpg
// module id = DC0d
// module chunks = 0 1